const initialState = {
  list: {
    isLoading: false,
    error: '',
    data: {
      items: [],
    },
  },
};

export default initialState;
